import { apiGet, apiPost, apiPut } from "app/services/apiServices";
import { AgTableClient } from "app/shared/AgTable";
import React, {
  forwardRef,
  useEffect,
  useRef,
  useState,
  useImperativeHandle,
  useContext,
} from "react";
import {
  API_ENDPOINT_FETCH_GST_CREDENTIALS_LIST,
  API_ENDPOINT_FETCH_GST_CREDENTIALS_LIST_TEMP,
  API_ENDPOINT_GST_CREDENTIAL_BULK_CREATE,
  API_ENDPOINT_GST_CREDENTIAL_UPDATE,
} from "../../credentials.constants";
import Loader from "app/shared/Loader";
import {
  PlusOutlined,
  ExportOutlined,
  LockOutlined,
  LockFilled,
} from "@ant-design/icons";
import {
  CheckCircleFilled,
  CloseCircleFilled,
  LoadingOutlined,
  ExclamationCircleFilled,
  CloseOutlined,
  CloseCircleOutlined,
  VerticalAlignBottomOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import { Button, Empty, Modal, Tag, message, Segmented, Input } from "antd";
import BulkCreateGSTCreds from "./components/BulkGSTCredential";
import AgTableEditButton from "app/shared/AgTable/AgTableClient/HelperTools/EditComponent";
import "../../Credentials.scss";
import PageHeader from "app/shared/PageHeader";
import { useRecoilState } from "recoil";
import { userInfo } from "app/config/States/users";
import TableViewSelector from "app/shared/TableViewSelector";
import { Mixpanel } from "app/config/Mixpanel";
import DownloadDoneIcon from "@mui/icons-material/DownloadDone";
import DownloadIcon from "@mui/icons-material/Download";
import Uploader from "app/shared/Uploader";
import * as XLSX from "xlsx";
import csv from "csvtojson";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import _cloneDeep from "lodash/cloneDeep";
import axios from "axios";
import { v4 as uuidv4 } from "uuid";
import { API_ENDPOINT_GST_UPDATE_BULK_OR_INSERT } from "../../credentials.constants";
import {
  UNSAFE_NavigationContext as NavigationContext,
  To,
} from "react-router-dom";
import { FinkAnalytics } from "app/utils/GoogleAnalytics";
import { getSubdomain } from "app/utils/generic.helper";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";

const GSTCredentials = forwardRef(function (props: any, ref: any) {
  const [tableData, setTableData] = useState<any[]>([]);
  const [tempData, setTempData] = useState<any[]>([]);
  const [columnDefs, setColumnDefs] = useState<any[]>([]);
  const [isLoading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();
  const [userDetails, _] = useRecoilState<any>(userInfo);
  const gridRef = useRef<any>(null);
  const gridApiRef = useRef<any>(null);
  const [isBulkModalVisible, setIsBulkModalVisible] = useState(false);
  const [uploadedFile, setUploadedFile] = useState<File | null>(null);
  const [uploadedData, setUploadedData] = useState<any[]>([]);
  const [gridApi, setGridApi] = useState<any>(null);
  const [originalData, setOriginalData] = useState<any[]>([]);
  const [integrating, setIntegrating] = useState(false);
  const [panList, setPanList] = useState<any[]>([]);
  const [filteredPANS, setFilteredPANS] = useState<any[]>([]);
  const [isRowAdded, setIsRowAdded] = useState(false);
  const [activeTab, setActiveTab] = useState("Failed");
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
  const POLL_INTERVAL = 10000;
  const intervalRef = useRef(null);
  const [refreshTimerId, setRefreshTimerId] = useState<ReturnType<
    typeof setInterval
  > | null>(null);
  const [activeSegment, setActiveSegment] = useState("FAILED");
  const isMounted = useRef(true);
  const [globalSearch, setGlobalSearch] = useState("");
  const [showResolutionPopup, setShowResolutionPopup] = useState(false);
  const [resolvedRows, setResolvedRows] = useState<any[]>([]);
  const [isPollingActive, setIsPollingActive] = useState(false); // Add this state to control polling
  const pendingUpdatesRef = useRef<Set<string>>(new Set());
  const domain = getSubdomain();

  const initialColDefs = [
    // {
    //   field: "customSortOrder",
    //   hide: true, // Hidden column just for sorting logic
    //   comparator: (a: any, b: any) => {
    //     const getPriority = (data: any) => {
    //       const status = data?.status || "";
    //       const username = data?.username;
    //       const password = data?.password;

    //       const statusList = status.split(",").map((s: string) => s.trim());

    //       const isPending = statusList.includes("PENDING");
    //       const isUserPassPresent = !!username && !!password;

    //       if (isPending) {
    //         // Priority order inside PENDING block
    //         if (isUserPassPresent) {
    //           if (statusList.includes("ACTIVE")) return 1;
    //           if (statusList.includes("INVALID") || statusList.includes("LOCKED")) return 2; // "Inactive"
    //           if (statusList.includes("EXCEPTION")) return 3; // "Error"
    //         }
    //         return 4;
    //       }

    //       return 5;
    //     };

    //     const aPriority = getPriority(a);
    //     const bPriority = getPriority(b);

    //     return aPriority - bPriority;
    //   },
    // },
    {
      field: "name",
      headerName: "Workspace",
      enableRowGroup: true,
      rowGroup:
        userDetails?.currentWorkspace?.meta?.full_access === true &&
        domain !== "sunpharma",
      hide:
        userDetails?.currentWorkspace?.meta?.full_access === true &&
        domain !== "sunpharma",
      minWidth: 200, 
      filter: "agTextColumnFilter",
      width: 200,
    },
    {
      field: "pan",
      headerName: "PAN",
      enableRowGroup: true,
      minWidth: 200,
      hide: true,
      filter: "agTextColumnFilter",
      // editable: (params: any) =>
      //   params.data?.isNew === true,
    },
    {
      field: "gstin",
      headerName: "GSTIN",
      enableRowGroup: true,
      minWidth: 200,
      filter: "agTextColumnFilter",
      editable: (params: any) => params.data?.isNew === true,
    },
    {
      field: "username",
      headerName: "Username",
      enableRowGroup: true,
      minWidth: 200,
      // editable: true,
      filter: "agTextColumnFilter",
      editable: () => true,
      valueParser: (params: any) => (params.newValue ?? "").toString().trim(),
      cellRenderer: (params: any) => {
        if (params?.node?.group) {
          return params.value;
        }
        const isEmpty = !params.value;
        return (
          <span style={{ color: isEmpty ? "#aaa" : "#000" }}>
            {isEmpty ? "Enter username" : params.value}
          </span>
        );
      },
    },

    {
      field: "password",
      headerName: "Password",
      minWidth: 200,
      enableRowGroup: true,
      editable: () => true,

      valueParser: (params: any) => (params.newValue ?? "").toString().trim(),

      // Treat null/undefined/0 as empty string
      valueGetter: (params: any) => {
        const rawValue = params.data?.password;
        return rawValue === null || rawValue === undefined || rawValue === 0
          ? ""
          : String(rawValue);
      },

      // Apply agTextColumnFilter for filtering
      filter: "agTextColumnFilter",

      // Show "Enter password" or masked password in the grid
      cellRenderer: (params: any) => {
        if (params?.node?.group) {
          return params.value;
        }
        const rawValue = params.value;
        const isEmpty =
          rawValue === null ||
          rawValue === undefined ||
          rawValue === "" ||
          rawValue === 0;

        if (isEmpty) {
          return <span style={{ color: "#aaa" }}>Enter password</span>;
        }

        const value = String(rawValue);
        const visiblePart = value.slice(-3);
        const maskedPart = "*".repeat(Math.max(0, value.length - 3));

        return (
          <span style={{ color: "#000" }}>{maskedPart + visiblePart}</span>
        );
      },

      // Optional: formatted value for clipboard export
      valueFormatter: (params: any) => {
        const rawValue = params.value;
        if (!rawValue) return "Enter password";

        const value = String(rawValue);
        const visiblePart = value.slice(-3);
        const maskedPart = "*".repeat(Math.max(0, value.length - 3));
        return maskedPart + visiblePart;
      },
    },
    {
      headerName: "Status",
      field: "status",
      enableRowGroup: true,
      valueGetter: (params: any) => {
        const status = params.data?.status || "UNKNOWN";
        switch (status) {
          case "ACTIVE":
            return "Valid";
          case "INVALID":
            return "Wrong Credential";
          // case "INVALID || FAILED":
          //   return "Wrong Credential";
          case "EXCEPTION":
          case "FAILED":
            return "Verification Failed";
          case "LOCKED":
            return "Locked";
          case "PENDING":
          case "PROCESSING":
            return "Pending";
          default:
            return "Not Available";
        }
      },
      cellRenderer: (params: any) => {
        const value = params.value;
        if (params.node?.group) {
          return "";
        }
        if (value === "Valid") {
          return <Tag color="green">Valid</Tag>;
        } else if (value === "Verification Failed") {
          return (
            <Tag style={{ borderColor: "#4682B499", color: "#4682B499" }}>
             Verification Failed
            </Tag>
          );
        } else if (value === "Locked") {
          return (
            <Tag style={{ borderColor: "#d55c1b99", color: "#d55c1b99" }}>
              <LockFilled /> Locked
            </Tag>
          );
        } else if (value === "Wrong Credential") {
          return (
            <Tag
              style={{
                backgroundColor: "#FDF2F0",
                borderColor: "red",
                color: "red",
              }}
            >
              <CloseCircleOutlined style={{ marginRight: "4px" }} />
              Wrong Credential
            </Tag>
          );
        } else if (value === "Pending") {
          return (
            <Tag
              style={{
                backgroundColor: "#E8F4FD",
                borderColor: "#1890FF",
                color: "#1890FF",
              }}
            >
              <LoadingOutlined style={{ marginRight: "4px" }} /> Pending
            </Tag>
          );
        } else {
          return (
            <Tag
              style={{
                backgroundColor: "#FEFBE8",
                borderColor: "#EFB141",
                color: "#EFB141",
              }}
            >
              <ExclamationCircleFilled style={{ marginRight: "2px" }} /> Not
              Available
            </Tag>
          );
        }
      },

      filter: "agSetColumnFilter",
      filterParams: {
        values: [
          "Valid",
          "Verification Failed",
          "Wrong Credential",
          "Pending",
          "Not Available",
        ],
      },
    },

    {headerName:"Action",minWidth: 200,enableRowGroup: true,cellRenderer: (params: any) => {
      return <Button type="primary" size="small" onClick={() => handleRetry(params.data)}>Retry</Button>;
    }},

    {
      field: "lastCredsUpdatedAt",
      headerName: "Last Edited",
      minWidth: 300,
      enableRowGroup: true,
      filter: "agDateColumnFilter",
      cellRenderer: (params: any) => {
        const value = params.value;
        if (!value) return ""; // null or undefined → empty
        const date = new Date(value);
        return isNaN(date.getTime()) ? "" : date.toLocaleDateString(); // valid date → formatted
      },
    },
  ];
  useEffect(() => {
    setColumnDefs(initialColDefs);
  }, []);
  useEffect(() => {
    Mixpanel.track("User Landed On GST Integration Page", {
      Screen: "GST Integration Page",
    });
    // fetchGSTCredentialsTemp();
    fetchGSTCredentials();
  }, [userDetails.currentWorkspace, props.type]);

  const fetchGSTCredentials = async (isAutoRefresh = false) => {
    if (!isMounted.current) return;
    if (!isAutoRefresh) {
      setLoading(true);
    }

    const response = await apiGet(API_ENDPOINT_FETCH_GST_CREDENTIALS_LIST);

    if (response.status) {
      const newData = response.data?.credentials || [];

      // Compare new data with current tableData to prevent unnecessary updates
      const isDataChanged =
        JSON.stringify(newData) !== JSON.stringify(originalData);

      if (isDataChanged) {
        if (isAutoRefresh) {
          // Check for rows that moved from PENDING to ACTIVE
          const movedToActive = newData.filter((newRow: any) => {
            const existingRow = originalData.find(
              (row) => row.id === newRow.id,
            );
            // Check if it was previously PENDING and now is ACTIVE
            const wasPending = existingRow?.status === "PENDING";
            const isNowActive = newRow.status === "ACTIVE";
            return wasPending && isNowActive;
          });

          if (movedToActive.length > 0) {
            setResolvedRows(movedToActive);
            setShowResolutionPopup(true);
          }
        }

        setOriginalData(_cloneDeep(newData));

        const filtered =
          activeSegment === "ACTIVE"
            ? newData.filter((item: any) => item.status === "ACTIVE")
            : newData.filter((item: any) => item.status !== "ACTIVE");

        setTableData(filtered);

        // Use AG Grid's applyTransactionAsync for efficient updates
        if (gridApi) {
          gridApi.applyTransactionAsync({ update: filtered });
        }
      } else {
      }
    } else {
      messageApi.error({
        type: "error",
        content: response.message,
      });
    }

    if (!isAutoRefresh) {
      setLoading(false);
    }
  };

  React.useImperativeHandle(ref, () => ({
    handleExportTableData,
  }));

  const updateGSTCredential = async (rowPayload: any) => {
    const response = await apiPut(API_ENDPOINT_GST_CREDENTIAL_UPDATE, {
      credentials: rowPayload,
    });
    if (response.status) {
      messageApi.success({
        type: "success",
        content: response.message,
      });
    } else {
      messageApi.error({
        type: "error",
        content: response.message,
      });
    }
  };

  const createGSTCredential = async (rowPayload: any) => {
    const response = await apiPost(API_ENDPOINT_GST_CREDENTIAL_BULK_CREATE, {
      credentials: [rowPayload],
    });
    if (response.status) {
      messageApi.success({
        type: "success",
        content: response.message,
      });
    } else {
      messageApi.error({
        type: "error",
        content: response.message,
      });
    }
  };

  const handleRowEdit = (rowData: any) => {
    if (rowData.id) {
      updateGSTCredential(rowData);
    } else {
      createGSTCredential(rowData);
    }
  };

  const handleExportTableData = () => {
    if (gridRef.current && gridRef.current.exportDataToExcel) {
      // Call the child component's function
      gridRef.current.exportDataToExcel();
    }
  };

  const handleApplyTableView = (viewData: any) => {
    if (viewData === "DEFAULT" || viewData === null) {
      setColumnDefs(initialColDefs);
      return;
    }
    setColumnDefs(viewData.columns);
    messageApi.success({
      type: "success",
      content: "View Applied",
    });
  };

  const handleSearchWorkspace = (query: string) => {
    if (gridRef.current && gridRef.current.exportDataToExcel) {
      // Call the child component's function
      gridRef.current.onTableSearch({ target: { value: query } });
    }
  };
  const handleCellEditingStarted = (event: any) => {
    // Stop polling when user starts editing
    if (isPollingActive) {
      stopAutoRefresh();
    }

    const saveBtn = document.getElementById("saveBtn");
    if (saveBtn) {
      //saveBtn.style.display = "inline-block";
      saveBtn.style.display = "flex";
      saveBtn.style.padding = "16px 40px"; // ⬅️ add padding here
      saveBtn.style.fontSize = "14px";
      saveBtn.style.borderRadius = "4px";
    }
  };

  // const onGridReady = (params: any) => {
  //   gridApiRef.current = params.api;

  //   setTimeout(() => {
  //     params.columnApi.applyColumnState({
  //       state: [{ colId: "customSortOrder", sort: "asc" }],
  //       defaultState: { sort: null },
  //     });
  //   }, 0);
  //   setGridApi(params.api)

  // };
  useEffect(() => {
    if (gridRef.current) {
      setGridApi(gridRef.current.api); // access api directly from ref
    }
  }, [gridRef.current]);

  const handleSaveClick = async () => {
    FinkAnalytics("user_clicked_gst_save_button", {
      event_category: "form_action",
      field: "gst_credential",
      workspace_name: userDetails?.currentWorkspace?.name || "unknown",
      user_id: userDetails?.id,
      subdomain: window.location.hostname.split(".")[0],
      timestamp: new Date().toISOString(),
      active_segment: activeSegment,
      action_type: "save_credentials",
    });

    const api = gridRef.current?.api;
    if (!api) return;

    const editableFields = ["username", "password"];
    const modifiedRows: any[] = [];
    const keyField = "id";

    setHasUnsavedChanges(false);

    const allNodes = api.getRenderedNodes();

    allNodes.forEach((node: any) => {
      // Skip group nodes (nodes without data or with group: true)
      if (!node.data || node.group) return;

      const id = node.data[keyField];
      const isNew = node.data?.isNew === true;

      if (isNew) {
        modifiedRows.push(node.data);
        return;
      }

      const original = originalData.find((item) => item[keyField] === id);
      if (!original) {
        return;
      }

      const isModified = editableFields.some((key) => {
        const newValue = (node.data[key] ?? "").toString();
        const oldValue = (original[key] ?? "").toString();
        return newValue !== oldValue;
      });

      if (isModified) {
        modifiedRows.push(node.data);
      }
    });

    if (modifiedRows.length === 0) {
      messageApi.info("No changes to save.");
      return;
    }

    const payload = modifiedRows.map((row) => ({
      id: row.id,
      gstin: row.gstin,
      username: row.username,
      password: row.password,
      status: row.status,
      workspace_id: row.workspace_id || userDetails?.currentWorkspace?.id,
    }));

    try {
      const response = await axios.post(
        API_ENDPOINT_GST_UPDATE_BULK_OR_INSERT,
        payload,
      );

      messageApi.success("Changes saved successfully!");

      // 1️⃣ Fetch latest data from API (fresh copy)
      const refreshedResponse = await apiGet(
        API_ENDPOINT_FETCH_GST_CREDENTIALS_LIST,
      );
      const newData = refreshedResponse.data?.credentials || [];

      // 2️⃣ Update originalData state
      setOriginalData(_cloneDeep(newData));

      // 3️⃣ Compute which rows to update in current table:
      const filtered =
        activeSegment === "ACTIVE"
          ? newData.filter((item: any) => item.status === "ACTIVE")
          : newData.filter((item: any) => item.status !== "ACTIVE");

      // 4️⃣ Set table data
      setGlobalSearch("");
      setTableData(filtered);

      // 5️⃣ Apply transaction (safe update)

      // 5️⃣ Hide Save button
      const saveBtn = document.getElementById("saveBtn");
      if (saveBtn) saveBtn.style.display = "none";

      // 6️⃣ Start auto-refresh only after successful save
      startAutoRefresh();
    } catch (error) {
      messageApi.error("Failed to save changes.");
    }
  };

  const startAutoRefresh = () => {
    if (refreshTimerId) clearInterval(refreshTimerId);

    const id = setInterval(() => {
      fetchGSTCredentials(true);
    }, 10000);

    setRefreshTimerId(id);
    setIsPollingActive(true); // Set polling as active
  };

  const stopAutoRefresh = () => {
    if (refreshTimerId) {
      clearInterval(refreshTimerId);
      setRefreshTimerId(null);
    }
    setIsPollingActive(false); // Set polling as inactive
  };

  const handleDownloadCsv = async () => {
    Mixpanel.track("Download Sample CSV", {
      Screen: "Workspace",
    });

    // Define only "ABC" in CSV
    let csvString = `GSTIN , Username, Password ,
    27AAACI1234F1Z5, testUser_01, testPass_01,
    07AACCD4567R1Z2, testUser_02, testPass_02,
    19AABCU7890K1Z8, testUser_03, testPass_03, `;

    try {
      // Convert the CSV string to a Blob
      const csvBlob = new Blob([csvString], { type: "text/csv" });

      // Convert the Blob object to a data URL
      const csvDataUrl = URL.createObjectURL(csvBlob);

      // Create a temporary anchor element
      const link = document.createElement("a");
      link.href = csvDataUrl;
      link.setAttribute("download", "workspace_sample.csv");

      // Trigger the download by programmatically clicking the anchor element
      document.body.appendChild(link);
      link.click();

      // Clean up
      document.body.removeChild(link);
    } catch (error) {
      console.error("Error downloading CSV file:", error);
    }
  };

  const handleUpload = async (file: any) => {
    const selectedFile = file.originFileObj || file;
    if (!file.originFileObj) {
      const reader = new FileReader();

      reader.onload = async (e: any) => {
        const binaryString = e.target.result;
        let jsonArray;

        if (file.type.includes("csv")) {
          //@ts-ignore
          jsonArray = await csv().fromString(binaryString);
        } else if (
          file.type.includes("sheet") ||
          file.type.includes("excel") ||
          file.name.endsWith(".xls") ||
          file.name.endsWith(".xlsx")
        ) {
          const workbook = XLSX.read(binaryString, { type: "binary" });
          const firstSheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[firstSheetName];
          jsonArray = XLSX.utils.sheet_to_json(worksheet);
        } else {
          return;
        }

        // Trim whitespace from each value in the JSON array
        jsonArray = jsonArray.map((row: any) => {
          return Object.fromEntries(
            Object.entries(row).map(([key, value]) => [
              key,
              typeof value === "string" ? value.trim() : value,
            ]),
          );
        });

        setUploadedData(jsonArray);
        setUploadedFile(selectedFile);
      };

      reader.readAsBinaryString(file);
    }
  };

  const handleReUpload = () => {
    setUploadedFile(null);
  };

  const handleBulkUpdateClick = () => {
    setIsBulkModalVisible(true);
  };

  const handleAddCredential = async ({
    password,
    username,
    // pan,
    gstin,
    workspace_id,
  }: {
    password: string;
    username: string;
    // pan: string;
    gstin: string;
    workspace_id: string;
  }) => {
    setIntegrating(true);

    const payload = [
      {
        workspace_id,
        password: password,
        username,
        gstin,
      },
    ];

    const response = await apiPost(
      // "http://192.168.0.144:7001/api/creds/gstportal/updateBulkOrInsertNew",
      API_ENDPOINT_GST_UPDATE_BULK_OR_INSERT,
      //API_ENDPOINT_CREDENTIAL_ADD_BULK,
      payload,
    );
    if (response.status) {
      messageApi.success(`Credential added`);
    } else {
      messageApi.error(`Failed to add credential`);
    }
    setIntegrating(false);
  };
  const handleAddRow = () => {
    const newItem = {
      name: userDetails?.currentWorkspace?.name || "-",
      gstin: "-",
      username: "-",
      password: "-",
      status: "EMPTY",
      isNew: true,
    };

    setTableData((prevState: any) => [newItem, ...prevState]);
    setIsRowAdded(true); //new---
  };

  const handleModalSubmit = async () => {
    if (uploadedData.length === 0) {
      messageApi.warning("No data uploaded");
      return;
    }

    try {
      const normalize = (val: any) =>
        (val ?? "").toString().trim().toLowerCase();
      const matchedData: any[] = [];
      const unmatchedRows: any[] = [];

      uploadedData.forEach((uploadedRow) => {
        const normalizedUploadedRow: Record<string, any> = {};
        Object.entries(uploadedRow).forEach(([key, val]) => {
          normalizedUploadedRow[key.toLowerCase()] = val;
        });

        const sampleGstins = [
          "27aaaci1234f1z5",
          "07aaccd4567r1z2",
          "19aabcu7890k1z8",
        ];
        if (sampleGstins.includes(normalize(normalizedUploadedRow["gstin"]))) {
          return;
        }
        const match = tableData.find(
          (gridRow) =>
            normalize(normalizedUploadedRow["gstin"]) ===
            normalize(gridRow.gstin),
        );

        if (match) {
          matchedData.push({
            id: match.id || match._id,
            workspace_id: match.workspace_id || match.workspaceId,
            password: (
              normalizedUploadedRow["password"] ??
              match.password ??
              ""
            )
              .toString()
              .trim(),
            username: (
              normalizedUploadedRow["username"] ??
              match.username ??
              ""
            )
              .toString()
              .trim(),
            gstin: (normalizedUploadedRow["gstin"] ?? match.gstin ?? "")
              .toString()
              .trim(),
          });
        } else {
          unmatchedRows.push(normalizedUploadedRow);
        }
      });

      if (matchedData.length > 0) {
        const response = await axios.post(
          API_ENDPOINT_GST_UPDATE_BULK_OR_INSERT,
          // "http://localhost:7001/api/creds/gstportal/updateBulkOrInsertNew",
          matchedData,
        );

        messageApi.success("Bulk update successful!");

        if (response.data?.credentials) {
          setTableData(response.data.credentials);
          setOriginalData(_cloneDeep(response.data.credentials));
        }
      }


      for (const row of unmatchedRows) {
        await handleAddCredential({
          password: row["password"] || "",
          // pan: row['pan'] || '',
          username: row["username"] || "",
          gstin: row["gstin"] || "",
          workspace_id: userDetails?.currentWorkspace.id,
        });
      }

      setIsBulkModalVisible(false);
      setUploadedData([]);
    } catch (error) {
      messageApi.error("Bulk update failed.");
    }
  };

  function usePrompt(when: boolean, message: string): void {
    const navigator = useContext(NavigationContext).navigator;

    useEffect(() => {
      if (!when) return;

      const push = navigator.push;
      const replace = navigator.replace;

      const confirm = (to: To): boolean => {
        // Convert `To` (string or object) to string for the prompt
        const destination = typeof to === "string" ? to : to.pathname || "/";
        return window.confirm(`${message}\n\nNavigating to: ${destination}`);
      };

      navigator.push = (...args: Parameters<typeof navigator.push>) => {
        if (confirm(args[0])) {
          push(...args);
        }
      };

      navigator.replace = (...args: Parameters<typeof navigator.replace>) => {
        if (confirm(args[0])) {
          replace(...args);
        }
      };

      return () => {
        navigator.push = push;
        navigator.replace = replace;
      };
    }, [navigator, when, message]);
  }

  usePrompt(
    hasUnsavedChanges,
    "You have unsaved changes. Are you sure you want to leave?",
  );

  useEffect(() => {
    const handleBeforeUnload = (e: BeforeUnloadEvent) => {
      if (hasUnsavedChanges) {
        e.preventDefault();
        e.returnValue = "";
      }
    };

    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => window.removeEventListener("beforeunload", handleBeforeUnload);
  }, [hasUnsavedChanges]);

  useEffect(() => {
    isMounted.current = true;

    return () => {
      isMounted.current = false;
      if (refreshTimerId) {
        clearInterval(refreshTimerId);
        setRefreshTimerId(null);
      }
    };
  }, []);

  useEffect(() => {
    if (!originalData.length) return;

    const filtered =
      activeSegment === "ACTIVE"
        ? originalData.filter((item) => item.status === "ACTIVE")
        : originalData.filter((item) => item.status !== "ACTIVE");

    setTableData(filtered);

    // Only start auto-refresh if polling is active (after save button is clicked)
    if (isPollingActive) {
      startAutoRefresh();
    }
  }, [activeSegment, originalData, isPollingActive]);

  const handleGlobalSearch = (searchValue: string) => {
    const trimmed = searchValue.trim().toLowerCase();

    if (!trimmed) {
      setTableData(originalData);
      return;
    }

    const filtered = originalData.filter((row) => {
      return (
        row.gstin?.toLowerCase().includes(trimmed) ||
        row.username?.toLowerCase().includes(trimmed) ||
        row.name?.toLowerCase().includes(trimmed)
      );
    });

    setTableData(filtered);
  };

  const handleDownloadCSVCreds = () => {
    if (!tableData || tableData.length === 0) {
      message.warning("No data available to download.");
      return;
    }

    // Map field keys to header names
    const columnMap = {
      name: "Workspace",
      gstin: "GSTIN",
      username: "Username",
      password: "Password",
      status: "Status",
    };

    const exportFields = Object.keys(columnMap);
    const headers = Object.values(columnMap).join(",") + "\n";

    const rows = tableData
      .map((row) =>
        exportFields
          .map((field) => {
            let value = row[field];

            // Wrap value in quotes if it contains commas
            if (typeof value === "string" && value.includes(",")) {
              value = `"${value}"`;
            }

            return value ?? "";
          })
          .join(","),
      )
      .join("\n");

    const csvContent = headers + rows;

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "creds.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleRetry = async (rowData: any) => {
    try {
      if (!rowData?.id) {
        messageApi.error("Invalid credential data. ID is missing.");
        return;
      }
  
      // Set row status to Pending immediately
      const updatedRow = {
        ...rowData,
        pendingUpdate: true
      };
  
      // Add to pending updates ref
      pendingUpdatesRef.current.add(rowData.id);
  
      // Update tableData state
      setTableData((prevData: any[]) => 
        prevData.map((row: any) => 
          row.id === rowData.id ? updatedRow : row
        )
      );
  
      // Update originalData state
      setOriginalData((prevData: any[]) => 
        prevData.map((row: any) => 
          row.id === rowData.id ? updatedRow : row
        )
      );
  
      // Update grid to show Pending status
      if (gridApi) {
        gridApi.applyTransactionAsync({ update: [updatedRow] });
      }
  
      const response = await apiPost("https://stage-apiplatform.finkraftai.com/api/meta/retryCredsStatus", {
        id: rowData.id,
        type: "gst"
      });
  
      // If status is 200 (success), API returns {"message":"Credentials status updated successfully"}
      // Since apiPost returns response.json(), if we get a message, it means status 200
      if (response.message) {
        // Status 200 - show success message with tick mark
        messageApi.success(response.message);
        // Refresh the data after a short delay to get updated status
        setTimeout(() => {
          fetchGSTCredentials(true);
        }, 1000);
      } else {
        // Status is not 200 - show error
        messageApi.error("Credentials status not updated. Please try again.");
      }
    } catch (error: any) {
      messageApi.error(error.message || "An error occurred while submitting retry request.");
    }
  };

  return (
    <div className="ScreenContainer">
      {props.componentType ? null : (
        <PageHeader
          title="GST Credentials"
          rightActions={
            <div style={{ display: "flex", alignItems: "center" }}>
              <div style={{ marginRight: 12 }}>
                <TableViewSelector
                  defaultColumns={columnDefs}
                  onViewSelect={handleApplyTableView}
                  id="GST_CRED_VIEW"
                />
              </div>

              <Button
                type="primary"
                size="small"
                icon={<ExportOutlined />}
                onClick={handleExportTableData}
                style={{ marginRight: 12 }}
              >
                Export
              </Button>
              <Button
                type="primary"
                size="small"
                icon={<PlusOutlined />}
                onClick={() => setShowModal(true)}
              >
                Add Bulk Credentials
              </Button>
            </div>
          }
        />
      )}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: "10px",
          marginTop: "10px",
        }}
      >
        <div
          style={{ paddingLeft: "10px", display: "flex", alignItems: "center" }}
        >
          <Segmented
            options={[
              { label: "Action Required", value: "FAILED" },
              { label: "No Action Required", value: "ACTIVE" },
            ]}
            value={activeSegment}
            onChange={(value) => {
              setActiveSegment(value);
            }}
            size="small"
          />
        </div>

        <div style={{ display: "flex", gap: "10px" }}>
          <div style={{ paddingLeft: "10px", marginBottom: "10px" }}>
            <Input
              placeholder="Search GSTIN or Username"
              value={globalSearch}
              onChange={(e) => {
                setGlobalSearch(e.target.value);
                handleGlobalSearch(e.target.value);
              }}
              allowClear
              prefix={
                <SearchOutlined
                  style={{ marginRight: "2px", color: "#72747d" }}
                />
              }
              style={{ width: "250px" }}
            />
          </div>
          <Button
            style={{
              color: "#0a8394",
              borderColor: "#0a8394",
              borderRadius: "4px",
              fontSize: "14px",
            }}
            onClick={handleDownloadCSVCreds}
          >
            {" "}
            Download GSTIN creds <VerticalAlignBottomOutlined />
          </Button>
          {!(userDetails?.currentWorkspace?.meta?.full_access === true) && (
            <Button
              style={{
                color: "#0a8394",
                borderColor: "#0a8394",
                borderRadius: "4px",
                fontSize: "14px",
              }}
              onClick={handleAddRow}
              icon={<PlusOutlined />}
            >
              Add New
            </Button>
          )}
          <Button
            id="saveBtn"
            type="primary"
            className="airlineSaveBtn"
            onClick={handleSaveClick}
            style={{ display: "none" }}
          >
            Save
          </Button>

          <Button
            id="bulkUpdateBtn"
            style={{
              padding: "15px 30px",
              borderRadius: "4px",
              color: "#FFF",
              fontSize: "14px",
              backgroundColor: "#0A8394",
              borderColor: "#0A8394",
              marginRight: "15px",
            }}
            className="airlineBulkBtn"
            onClick={handleBulkUpdateClick}
          >
            Bulk Upload
          </Button>
        </div>
      </div>

      <div className="TableContainer">
        {isLoading ? (
          <Loader />
        ) : tableData.length === 0 && tempData.length === 0 ? (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              width: "100%",
              height: "100%",
              justifyContent: "center",
            }}
          >
            <Empty />
          </div>
        ) : (
          <div
            className="ag-theme-alpine"
            style={{ height: "90vh", width: "100%" }}
          >
            <AgTableClient
              // @ts-ignore
              rowData={(tableData.length > 0 ? tableData : tempData) || []}
              columnDefs={columnDefs}
              groupPanel
              onRowSaved={handleRowEdit}
              ref={gridRef}
              footer={false}
              autoResize
              showStatusBar
              singleClickEdit={true}
              enableDirectEdit
              onCellEditingStarted={handleCellEditingStarted}
              // onGridReady={onGridReady}
            />
          </div>
        )}
      </div>

      <Modal
        title="Create Bulk Credentials"
        open={showModal}
        footer={false}
        onCancel={() => setShowModal(false)}
        width={800}
      >
        <div style={{ marginTop: 24 }}>
          <BulkCreateGSTCreds onFinish={() => setShowModal(false)} />
        </div>
      </Modal>

      <Modal
        title="Bulk Upload"
        open={isBulkModalVisible}
        footer={null}
        onCancel={() => setIsBulkModalVisible(false)}
        width={500}
        style={{ width: 500 }}
      >
        <div style={{ display: "flex", justifyContent: "flex-end" }}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              backgroundColor: "#e5f6f7",
              borderRadius: "4px",
              padding: "6px 12px",
              cursor: "pointer",
              width: "fit-content",
              marginBottom: "20px",
              marginTop: "20px",
            }}
            onClick={handleDownloadCsv}
          >
            <DownloadIcon
              style={{
                marginRight: "6px",
                color: "#0a8394",
                width: "14px",
                height: "18px",
              }}
            />
            <span style={{ color: "#0a8394", fontWeight: 500 }}>
              Sample bulk upload file
            </span>
          </div>
        </div>

        {/* Upload or Uploaded file status */}
        {!uploadedFile ? (
          <Uploader onSelect={handleUpload} />
        ) : (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "10px",
                flexDirection: "column",
              }}
            >
              <DownloadDoneIcon
                style={{
                  color: "#008000",
                  fontSize: "20px",
                  width: "70px",
                  height: "80px",
                }}
              />
              <span style={{ fontWeight: 800, color: "" }}>File uploaded</span>
            </div>
            <span
              onClick={handleReUpload}
              style={{
                display: "flex",
                alignContent: "center",
                color: "#0a8394",
                cursor: "pointer",
                backgroundColor: "#e5f6f7",
                borderRadius: "4px",
                padding: "4px 6px",
                marginTop: "7px",
              }}
            >
              Repload <FileUploadIcon />
            </span>
          </div>
        )}

        <div
          style={{
            display: "flex",
            gap: "16px",
            justifyContent: "space-between",
            marginTop: "30px",
          }}
        >
          <Button
            onClick={() => setIsBulkModalVisible(false)}
            style={{
              padding: "17px 60px",
              justifyContent: "center",
              alignItems: "center",
              borderRadius: "8px",
              fontSize: "16px",
              color: "#0A8394",
              borderColor: "#0A8394",
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleModalSubmit}
            style={{
              padding: "18px 60px",
              justifyContent: "center",
              alignItems: "center",
              borderRadius: "8px",
              fontSize: "16px",
              color: "#FFF",
              backgroundColor: "#0A8394",
            }}
          >
            Submit
          </Button>
        </div>
      </Modal>

      <Modal
        title="🎉 GST Credentials Resolved!"
        open={showResolutionPopup}
        onCancel={() => setShowResolutionPopup(false)}
        footer={[
          <Button
            key="ok"
            type="primary"
            onClick={() => setShowResolutionPopup(false)}
          >
            Great!
          </Button>,
        ]}
        width={500}
      >
        <div style={{ textAlign: "center", padding: "20px 0" }}>
          <CheckCircleFilled
            style={{ fontSize: "48px", color: "#52c41a", marginBottom: "16px" }}
          />
          <h3>Action No Longer Required</h3>
          <p>The following GST credentials have been successfully resolved:</p>
          <div style={{ marginTop: "16px", textAlign: "left" }}>
            {resolvedRows.map((row, index) => (
              <div
                key={row.id}
                style={{
                  padding: "8px 12px",
                  backgroundColor: "#f6ffed",
                  border: "1px solid #b7eb8f",
                  borderRadius: "4px",
                  marginBottom: "8px",
                }}
              >
                <strong>{row.gstin}</strong> - {row.name}
              </div>
            ))}
          </div>
          <p style={{ marginTop: "16px", color: "#666" }}>
            These GST credentials are now working properly and no longer require
            your attention.
          </p>
        </div>
      </Modal>
      {contextHolder}
    </div>
  );
});

export default GSTCredentials;
